import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addedItems: [],
  productCategories: [],
};

export const purchaseRequestSlice = createSlice({
  name: "purchaseRequest",
  initialState,
  reducers: {
    clearAll: (stateVal) => initialState,

    updateAddToCart: (state, action) => {
      const newItems = [...state.addedItems, action.payload];
      state.addedItems = newItems;
    },

    incrementItemCountInCart: (state, action) => {
      let newItems = [...state.addedItems];
      for (let i = 0; i < newItems.length; i++) {
        if (newItems[i].id === action.payload['id']) {
          newItems[i] = action.payload;
        }
      }
      state.addedItems = newItems;
    },

    decrementItemCountInCart: (state, action) => {
      let newItems = [...state.addedItems];
      for (let i = 0; i < newItems.length; i++) {
        if (newItems[i].id === action.payload['id']) {
          newItems[i] = action.payload;
        }
      }
      state.addedItems = newItems;
    },

    removeFromCart: (state, action) => {
      const itemId = action.payload;
      state.addedItems = state.addedItems.filter((item) =>
        item.id !== itemId);
    },
    
    removeAllFromCart: (state, action) => {
      state.addedItems = [];
    },

    updateProductCategories: (state, action) => {
      const newCategories = [...state.productCategories, action.payload];
      state.productCategories = newCategories;
    },

  }
});

export const { clearAll, removeFromCart,
  removeAllFromCart,
  updateAddToCart, incrementItemCountInCart,
  decrementItemCountInCart, updateProductCategories
} = purchaseRequestSlice.actions;

export default purchaseRequestSlice.reducer;
